import { render, staticRenderFns } from "./donation-error.vue?vue&type=template&id=359f0add&lang=pug"
import script from "./donation-error.vue?vue&type=script&lang=js"
export * from "./donation-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports